/**
 * Copyright (c) 2026 Accunai India Services Pvt. Ltd. All rights reserved.
 *
 * PROPRIETARY AND CONFIDENTIAL
 *
 * This file is part of proprietary software owned by Accunai India Services Pvt. Ltd.
 * Unauthorized copying, distribution, modification, or use of this file,
 * in whole or in part, via any medium, is strictly prohibited without
 * prior written permission from Accunai India Services Pvt. Ltd.
 *
 * Generated with GitHub Copilot Business/Enterprise.
 * Reviewed and approved by: AI-assisted / 2026-08-13
 */

import { httpClient } from "./httpClient";
import { RequestOtpInput, VerifyOtpApiResponse, VerifyOtpInput } from "../features/auth/model/types";

const LOGIN_PATH = "auth/company/user/login/other/";
const VERIFY_OTP_PATH = "auth/company/user/login/other/verify/";

export const requestLoginOtp = async (payload: RequestOtpInput): Promise<void> => {
  await httpClient.post(LOGIN_PATH, payload);
};

export const verifyLoginOtp = async (
  payload: VerifyOtpInput
): Promise<VerifyOtpApiResponse> => {
  const response = await httpClient.post<VerifyOtpApiResponse>(VERIFY_OTP_PATH, payload);
  return response.data;
};
